import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Tooltip,
    Typography
} from "@mui/material";
import { getPager } from "helper/common";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getLabRecords } from "store/app/farm-management/farm-records/actions";
import MainCard from "ui-component/cards/MainCard";
import SubCard from "ui-component/cards/SubCard";
import { VWPagination } from "ui-component/custom-components/pagination";
import Chip from "ui-component/extended/Chip";

const LabReports = (props) => {
    const params = useParams();
    const { farmIndex } = params || {};

    const [pageSize, setPageSize] = useState(10);
    const [Pager, setPager] = useState({ currentPage: 1 });
    const { labRecords, totalCounts } = props;
    useEffect(() => {
        if (farmIndex) {
            props.getLabRecords(farmIndex)
        }
    }, [farmIndex])

    const setPage = (page = 1) => {
        props.getLabRecords(farmIndex);

        setPager(prevPager => {
            const totalPages = Math.ceil(totalCounts / pageSize);
            const visiblePages = 4;
            const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
            const newPages = [];
            for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
                newPages.push(i);
            }
            return {
                ...prevPager,
                currentPage: page,
                totalPages,
                pages: newPages,
            }
        })
    }

    useEffect(() => {
        const currentPager = getPager(totalCounts, 1, pageSize);
        setPager(currentPager)
    }, [totalCounts]);

    console.log("farmIndex: ", farmIndex)
    console.log("labRecords: ", labRecords)
    return (
        <>
            <SubCard sx={{
                p: 1.5,
                pl: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
            >
                <Grid item sx={{ display: 'flex', gap: 2, alignItems: "center" }}>
                    <Typography variant="h4">Lab Records List - </Typography>
                    <Tooltip title="Lab Records Count" placement="top">
                        <span>
                            <Chip
                                label={totalCounts}
                                chipcolor="secondary"
                                size="small"
                                sx={{
                                    borderRadius: "20%",
                                    py: 1,
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    cursor: "pointer"
                                }}
                            />
                        </span>
                    </Tooltip>
                </Grid>
                {/* <Grid item sx={{ display: 'flex', gap: 2 }}>
                    <Badge
                        badgeContent={filterCount}
                        color="secondary"
                        invisible={filterCount === 0}
                    >
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleFilterOpen}
                            startIcon={<IconFilter />}
                        >
                            Filter
                        </Button>
                    </Badge>
                </Grid> */}
            </SubCard>
            <Grid container columnSpacing="16" rowSpacing="16" sx={{ marginTop: '0px' }}>
                {labRecords && labRecords.map((labData, index) => {
                    return (
                        <Grid item md="4" key={index}>
                            <MainCard sx={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px" }}>
                                <TableContainer>
                                    <Table size="small" sx={{ whiteSpace: "nowrap" }}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: "bold" }}>Lab Record No.</TableCell>
                                                <TableCell>{labData.LabRecordsIndex || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: "bold" }}> Report Name</TableCell>
                                                <TableCell>{labData.ReportName || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: "bold" }}> Observation</TableCell>
                                                <TableCell>{labData.Observation || "N/A"}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </MainCard>
                        </Grid>
                    )
                })}
            </Grid>
            {(totalCounts > 0) &&
                <Grid>
                    <VWPagination
                        pageDetails={Pager}
                        pageChange={setPage}
                        totalRecords={totalCounts}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </Grid>
            }
        </>
    )
}

const mapStateToProps = (state) => ({
    labRecords: state.farmRecords.labRecords,
    totalCounts: state.farmRecords.labRecordsCount,
    isPending: state.farmRecords.isLabRecordSPending,
    errorMessage: state.farmRecords.labRecordsErrorMessage,
})

const mapDispatchToProps = (dispatch) => ({
    getLabRecords: (filter) => dispatch(getLabRecords(filter)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LabReports);